import React, { useState, useEffect } from "react";
import Delete from "../../assets/Icon/delete.svg";
import Edit from "../../assets/Icon/Edit-blue.svg";
import DragIndicator from "../../assets/Icon/drag_indicator 1.svg";
import ApiCalling from "../../network/ApiCalling";
import { useTranslation } from "react-i18next";
import ModalComponent from "../Dashbord/ModalComponent";
import ToastHOC from "../HOC/ToastHOC";
import Invalid from "../../assets/Icon/invalid.svg";
import Spinner from "react-bootstrap/Spinner";
import Loader from "../../components/common/Loader";

const DevelopmentArea = (props) => {
  const data = props.data;
  const { setIsToast, setIsSubToast } = props;
  const [formData, setFormData] = useState([]);
  const { t } = useTranslation();
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [removeSubject, setRemoveSubject] = useState({ index: 0, id: 0 });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isLoadingList, setIsLoadingList] = useState(false);

  const gettemplateInfo = () => {
    setIsLoadingList(true);
    const req = {
      id: data,
    };
    ApiCalling.apiCallBodyDataPost("assessments/listByTemplateId", req)
      .then((res) => {
        if (res.data) {
          const finalData = res.data.map((curriculum) => ({
            subject: curriculum.DevelopmentArea.map((sub) => ({
              subject: { id: sub?.id, title: sub.title },
              areas: sub.SubDevArea.map((area) => ({
                area: { id: area?.id, title: area.title },
                milestones: area.Milestones.map((milestone) => ({
                  id: milestone?.id,
                  title: milestone.title,
                  position_id: milestone?.position_id,
                })),
                isEditing: false,
              })),
              isEditing: false,
              isOpen: false,
            })),
          }));
          setFormData(finalData[0]?.subject);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoadingList(false);
      });
  };

  useEffect(() => {
    gettemplateInfo();
  }, []);

  const toggleEdit = (index, areaIndex) => {
    const updatedFormData = [...formData];
    updatedFormData[index].areas[areaIndex].isEditing =
      !updatedFormData[index].areas[areaIndex].isEditing;
    updatedFormData[index].areas[areaIndex].isEditing == true
      ? (updatedFormData[index].isOpen = true)
      : (updatedFormData[index].isOpen = false);
    if (areaIndex === 0) {
      updatedFormData[index].isEditing = !updatedFormData[index].isEditing;
    }
    setFormData(updatedFormData);
  };

  const toggleAccordion = (index) => {
    console.log(formData[index]);
    const updatedFormData = [...formData];
    updatedFormData[index].isOpen = !updatedFormData[index].isOpen;
    setFormData(updatedFormData);
  };

  const close = (index, areaIndex) => {
    const updatedFormData = [...formData];
    console.log(formData);
    const subjectToClose = updatedFormData[index];
    const areaToClose = subjectToClose?.areas[areaIndex];
    console.log(subjectToClose, areaToClose);
    // if (areaToClose) {
    //   console.log("4")
    //   if(areaToClose?.id === undefined && (areaToClose?.area === "" || areaToClose?.area.value === "")){
    //     updatedFormData.splice(index, 1);
    //   }
    //   areaToClose.isEditing = !areaToClose.isEditing;
    //   areaToClose.milestones = areaToClose.milestones.filter(
    //     (milestone) => milestone !== ""
    //   );
    // }
    // if (areaIndex === 0 && subjectToClose.subject !== "") {
    //   subjectToClose.isEditing = !subjectToClose.isEditing;
    // } else {
    //   console.log("1");
    //   if (subjectToClose?.subject === "") {
    //     console.log("2");
    //     updatedFormData.splice(index, 1);
    //   }
    //   // else if (areaToClose?.area === "") {
    //   //   console.log("3", index)
    //   //   console.log(updatedFormData[index])
    //   //   updatedFormData[index].areas.splice(areaIndex, 1);
    //   // }
    //   else if(areaToClose?.area?.id !== undefined && areaToClose?.area?.value !== ""){
    //     console.log("5")
    //     gettemplateInfo();
    //   }
    // }

    // //with ids
    // if(areaIndex === 0 && subjectToClose.subject.value !== "" && subjectToClose.subject.id !== undefined){
    //   console.log("ceck",updatedFormData);
    //   gettemplateInfo();
    // }

    //Logic for without id i.e its a new data
    subjectToClose.isEditing = !subjectToClose.isEditing;
    subjectToClose.isOpen = !subjectToClose.isOpen;
    if (
      subjectToClose?.subject === "" &&
      subjectToClose?.subject?.id === undefined
    ) {
      updatedFormData.splice(index, 1);
    }
    if (areaToClose?.area === "" && areaToClose?.area?.id === undefined) {
      areaToClose.isEditing = !areaToClose.isEditing;
      updatedFormData.splice(index, 1);
    }
    if (areaToClose?.milestones[0] === "") {
      updatedFormData.splice(index, 1);
    }

    //logic with id i.e its edited data
    if (
      subjectToClose?.subject?.id !== undefined ||
      areaToClose?.area?.id !== undefined
    ) {
      gettemplateInfo();
    }

    setFormData(updatedFormData);
    setErrors({});
  };

  const handleChange = (
    e,
    index,
    type,
    id,
    areaIndex = null,
    milestoneIndex = null
  ) => {
    const { name, value } = e.target;
    console.log(value);
    const newFormData = [...formData];
    if (value === "") {
      validateForm();
    }
    if (type === "subject") {
      newFormData[index][name] = { id: id, value: value };
    } else if (type === "area") {
      newFormData[index].areas[areaIndex][name] = { id: id, value: value };
    } else if (type === "milestone") {
      newFormData[index].areas[areaIndex].milestones[milestoneIndex] = {
        id: id,
        value: value,
        position_id: milestoneIndex,
      };
    }
    // console.log("change", newFormData)
    setFormData(newFormData);
  };

  const handleRemoveSubject = () => {
    const newFormData = [...formData];
    newFormData.splice(removeSubject?.index, 1);
    ApiCalling.apiCallDelete(`assessments/subject/${removeSubject?.id}`)
      .then((res) => {
        setFormData(newFormData);
        setShowDeleteConfirmation(false);
        setIsToast("Framework Deleted!");
        setIsSubToast("Framework deleted successfully");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDelete = (index, id) => {
    setShowDeleteConfirmation(true);
    setRemoveSubject({ index: index, id: id });
  };

  const handleAddArea = (index) => {
    const newFormData = [...formData];
    newFormData[index].areas.push({
      area: "",
      milestones: [""],
      isEditing: true,
    });
    setFormData(newFormData);
  };

  const handleRemoveArea = (index, areaIndex, id) => {
    const newFormData = [...formData];
    newFormData[index].areas.splice(areaIndex, 1);
    setFormData(newFormData);
    removeArea(id);
  };

  const removeArea = (id) => {
    ApiCalling.apiCallDelete(`assessments/area/${id}`)
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleAddMilestone = (index, areaIndex) => {
    const newFormData = [...formData];
    newFormData[index].areas[areaIndex].milestones.push("");
    setFormData(newFormData);
  };

  const handleRemoveMilestone = (index, areaIndex, milestoneIndex, id) => {
    const newFormData = [...formData];
    newFormData[index].areas[areaIndex].milestones.splice(milestoneIndex, 1);
    setFormData(newFormData);

    const milestoneErrorKey = `milestone-${index}-${milestoneIndex}`;
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[milestoneErrorKey];
      return newErrors;
    });

    if (id) {
      removeMilestone(id);
    }
  };

  const removeMilestone = (id) => {
    ApiCalling.apiCallDelete(`assessments/milestone/${id}`)
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDragStart = (e, index, position_id) => {
    e.dataTransfer.setData("draggedItemIndex", position_id);
  };

  const handleDrop = async (
    e,
    dropIndex,
    position_id,
    milestone_id,
    areaIndex,
    index
  ) => {
    const draggedMilestonePosition = e.dataTransfer.getData("draggedItemIndex");
    console.log(draggedMilestonePosition);
    console.log(dropIndex, milestone_id, areaIndex);
    const updatedFormData = [...formData];
    console.log(updatedFormData);
    const subject = updatedFormData.filter(
      (item) => item.isEditing == true || item.isOpen == true
    );
    console.log(subject, index, areaIndex);
    const area = subject[0].areas[areaIndex];
    console.log(area, dropIndex);
    const draggedMilestone = area.milestones.find(
      (milestone) => milestone.position_id === Number(draggedMilestonePosition)
    );

    const dropMilestone = area.milestones.find(
      (milestone) => milestone.position_id === dropIndex
    );
    console.log(draggedMilestone, dropMilestone);
    if (draggedMilestone && dropMilestone) {
      area.milestones = area.milestones.filter(
        (milestone) => milestone.id !== draggedMilestone.id
      );

      area.milestones.splice(dropIndex, 0, draggedMilestone);

      area.milestones.forEach((milestone, index) => {
        milestone.position_id = index;
      });
      setFormData(updatedFormData);
      console.log(updatedFormData[index].areas[areaIndex]);
      // try {
      //   let finalData = [];
      //   for (const item of updatedFormData[index].areas[areaIndex].milestones) {
      //     console.log(item.position_id, item.id);
      //     finalData.push(

      //       await updateMilestonePosition(item.position_id, item.id)
      //     );
      //     if (finalData.length == updatedFormData[index].areas[areaIndex].milestones) {
      //       gettemplateInfo(true);
      //     }
      //   }
      // } catch (err) {
      //   console.log(err);
      // }
    }
  };

  // const updateMilestonePosition = (position_id, milestone_id) => {
  //   const data = {
  //     position_id: position_id,
  //     id: milestone_id,
  //   };
  //   return new Promise(async (resolve, reject) => {
  //     //   setTimeout(async () => {
  //     try {
  //       const res = await ApiCalling.apiCallBodyDataPost(
  //         "assessments/update-position",
  //         data
  //       );
  //       console.log(res);
  //       resolve(res.data);
  //     } catch (err) {
  //       reject(err);
  //       console.error(err);
  //     }
  //   });
  // };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const validateForm = () => {
    const newErrors = {};
    formData.forEach((subjectData, subjectIndex) => {
      // console.log(
      //   subjectData?.subject === "" || subjectData?.subject.value === "",
      //   subjectData?.subject
      // );
      if (subjectData?.subject === "" || subjectData?.subject?.value === "") {
        newErrors[`subject-${subjectIndex}`] = "Subject title cannot be empty.";
      }
      subjectData.areas.forEach((areaData, areaIndex) => {
        const areaValue = areaData?.area === "" || areaData?.area?.value || "";
        if (
          areaData.area === "" ||
          areaData.area.value === "" 
        ) {
          newErrors[`area-${subjectIndex}-${areaIndex}`] =
            "Area title cannot be empty.";
        }

        // if (
        //   areaData.milestones[0] === "" ||
        //   areaData.milestones[0].value === ""
        // ) {
        //   newErrors[`milestone-${subjectIndex}-0`] =
        //     "Milestone title cannot be empty.";
        // }
        areaData.milestones.forEach((milestone, milestoneIndex) => {
          const milestoneTitle = milestone?.title || milestone?.value || "";
          if (
            milestone === "" ||
            milestone?.value === "" ||
            milestone?.title === "" ||
            milestoneTitle.trim() === ""
          ) {
            newErrors[`milestone-${subjectIndex}-${milestoneIndex}`] =
              "Milestone title cannot be empty.";
          }
        });
      });
    });
    // console.log(formData)
    // console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (index, areaIndex) => {
    setLoading(true);
    const newFormData = [...formData];
    const submitData = newFormData[index];
    // newFormData[index].areas[areaIndex].milestones = newFormData[index].areas[
    //   areaIndex
    // ].milestones.filter((milestone) => milestone !== "");
    console.log(newFormData);
    console.log(validateForm())
    if (validateForm()) {
      submitData.curriculum_framework_id = data;
      console.log("subject", submitData);
      ApiCalling.apiCallBodyDataPost(
        "assessments/add-development-area",
        submitData
      )
        .then((res) => {
          if (res.data.status) {
            setIsToast(
              submitData?.subject?.id === undefined
                ? "Framework Created!"
                : "Framwork Updated!"
            );
            setIsSubToast(
              submitData?.subject?.id === undefined
                ? "Framework created successfully"
                : "Framework updated successfully"
            );
            close(index, areaIndex);
            gettemplateInfo();
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
          setErrors({});
        });
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-end align-items-center gap-2">
        <button
          className="btn ternary-text"
          type="button"
          onClick={() => {
            setFormData([
              ...formData,
              {
                subject: "",
                areas: [
                  {
                    area: "",
                    milestones: [""],
                    isEditing: true,
                  },
                ],
                isEditing: true,
                isOpen: true,
              },
            ]);
          }}
        >
          {t("+ Add New")}
        </button>
      </div>
      <form>
        {isLoadingList ? (
          <Loader />
        ) : (
          <div className="accordion" id="accordionExample">
            {formData.map((subjectData, index) => (
              <div key={index} className="accordion-item">
                <div className="accordion-header" id={`heading${index}`}>
                  <div className="d-flex justify-content-between p-3">
                    {subjectData.isEditing ? (
                      <div className="w-100">
                        <label className="mt-2">Subject</label>
                        <div className="d-flex justify-content-center align-content-item mb-2">
                          <input
                            type="text"
                            name="subject"
                            value={subjectData.subject?.title}
                            className={`form-control custom-input ${
                              errors[`subject-${index}`] ? "is-invalid" : ""
                            }`}
                            onChange={(e) =>
                              handleChange(
                                e,
                                index,
                                "subject",
                                subjectData.subject?.id
                              )
                            }
                            placeholder="Subject"
                          />
                          {subjectData.isEditing && (
                            <a
                              type="button"
                              onClick={() => {
                                handleDelete(index, subjectData?.subject?.id);
                              }}
                              className="d-flex ms-2"
                            >
                              <img src={Delete} alt="Delete" width={20} />
                            </a>
                          )}
                        </div>
                        {errors[`subject-${index}`] && (
                          <div className="text-danger">
                            {errors[`subject-${index}`]}
                          </div>
                        )}
                      </div>
                    ) : (
                      <span className="lg-text">
                        {subjectData.subject?.title || "No Subject Title"}
                      </span>
                    )}
                    {!subjectData.isEditing && (
                      <div className="d-flex justify-content-end align-items-center">
                        <div className="vertical-bar"></div>
                        <div
                          className="accoridan-btn"
                          onClick={() => toggleAccordion(index)}
                        >
                          <i
                            className={
                              subjectData?.isOpen
                                ? "fa fa-angle-up"
                                : "fa fa-angle-down"
                            }
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  id={`collapse${index}`}
                  className={`accordion-collapse collapse ${
                    subjectData.isOpen ? "show" : ""
                  }`}
                  aria-labelledby={`heading${index}`}
                  data-bs-parent="#accordionExample"
                >
                  <div className="px-3">
                    {subjectData.areas.map((areaData, areaIndex) => (
                      <div key={areaIndex}>
                        {areaData.isEditing ? (
                          <div>
                            <label className="mt-2">Area</label>
                            <div className="d-flex mb-2">
                              <input
                                type="text"
                                name="area"
                                className={`form-control custom-input ${
                                  errors[`area-${index}-${areaIndex}`]
                                    ? "is-invalid"
                                    : ""
                                }`}
                                value={areaData.area.title}
                                onChange={(e) =>
                                  handleChange(
                                    e,
                                    index,
                                    "area",
                                    areaData.area.id,
                                    areaIndex
                                  )
                                }
                                placeholder="Area"
                              />
                              {areaData.isEditing && areaIndex > 0 ? (
                                <a
                                  type="button"
                                  onClick={() =>
                                    handleRemoveArea(
                                      index,
                                      areaIndex,
                                      areaData?.area?.id
                                    )
                                  }
                                  className="d-flex ms-2"
                                >
                                  <img src={Delete} alt="Delete" width={20} />
                                </a>
                              ) : (
                                <div style={{ width: "32px" }}></div>
                              )}
                            </div>
                            <div>
                              {errors[`area-${index}-${areaIndex}`] && (
                                <div className="text-danger">
                                  {errors[`area-${index}-${areaIndex}`]}
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className="row align-items-center mb-2">
                            <div className="col-md">
                              <ul className="bullets">
                                <li>
                                  <span className="md-sm-text">
                                    {areaData.area?.title}
                                  </span>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-2">
                              {!areaData.isEditing && (
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleEdit(index, areaIndex);
                                  }}
                                  className="btn btn-sm ms-2 ternary-text"
                                >
                                  <>
                                    <img
                                      src={Edit}
                                      alt=""
                                      className="edit-svg "
                                    />
                                    {t("Edit")}
                                  </>
                                </button>
                              )}
                            </div>
                          </div>
                        )}

                        {areaData.isEditing && (
                          <label
                            className="mt-2"
                            style={{ marginLeft: "20px" }}
                          >
                            Milestone's
                          </label>
                        )}
                        {areaData.milestones.map(
                          (milestone, milestoneIndex) => (
                            <div
                              key={milestoneIndex}
                              style={{ marginLeft: "20px" }}
                            >
                              {areaData.isEditing ? (
                                <div>
                                  <div
                                    key={milestoneIndex}
                                    draggable={milestone.value !== ""}
                                    onDragStart={(e) => {
                                      if (milestone.value !== "") {
                                        handleDragStart(
                                          e,
                                          milestoneIndex,
                                          milestone?.position_id
                                        );
                                      }
                                    }}
                                    onDrop={(e) => {
                                      if (milestone.value !== "") {
                                        handleDrop(
                                          e,
                                          milestoneIndex,
                                          milestone?.position_id,
                                          milestone?.id,
                                          areaIndex,
                                          index
                                        );
                                      }
                                    }}
                                    onDragOver={handleDragOver}
                                    className="d-flex justify-content-center align-content-center"
                                    style={{
                                      background: "white",
                                      padding: "10px",
                                      cursor: "move",
                                    }}
                                  >
                                    <img
                                      src={DragIndicator}
                                      draggable="false"
                                    />
                                    <input
                                      type="text"
                                      placeholder="Milestone"
                                      value={milestone?.title}
                                      onChange={(e) =>
                                        handleChange(
                                          e,
                                          index,
                                          "milestone",
                                          milestone?.id,
                                          areaIndex,
                                          milestoneIndex
                                        )
                                      }
                                      className={`form-control custom-input ${
                                        errors[
                                          `milestone-${index}-${milestoneIndex}`
                                        ]
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                    />
                                    {areaData.isEditing &&
                                    milestoneIndex > 0 ? (
                                      <a
                                        type="button"
                                        onClick={() =>
                                          handleRemoveMilestone(
                                            index,
                                            areaIndex,
                                            milestoneIndex,
                                            milestone?.id
                                          )
                                        }
                                        className="d-flex ms-2"
                                      >
                                        <img
                                          src={Delete}
                                          alt="Delete"
                                          width={20}
                                        />
                                      </a>
                                    ) : (
                                      <div style={{ width: "28px" }}></div>
                                    )}
                                  </div>
                                  {errors[
                                    `milestone-${index}-${milestoneIndex}`
                                  ] && (
                                    <div className="text-danger ps-4">
                                      {
                                        errors[
                                          `milestone-${index}-${milestoneIndex}`
                                        ]
                                      }
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div className="md-sm-text2 ms-3 mb-2">
                                  {milestone?.title}
                                </div>
                              )}
                            </div>
                          )
                        )}
                        {areaData?.isEditing && (
                          <div className="p-2">
                            <button
                              className="btn ternary-text"
                              type="button"
                              onClick={() =>
                                handleAddMilestone(index, areaIndex)
                              }
                            >
                              + Add New Milestone
                            </button>
                          </div>
                        )}
                        {areaData.isEditing && (
                          <>
                            <div className="d-flex gap-2 align-items-center justify-content-end">
                              {/* {error.length > 0 && (
                              <div className="invalid-error px-0">
                                <img
                                  className="fa fa-exclamation-circle mr-2 invalid-svg"
                                  src={Invalid}
                                />
                                {error}
                              </div>
                            )} */}
                            </div>
                            <div className="d-flex gap-2 align-items-center justify-content-end p-3">
                              <button
                                type="button"
                                className="secondary-md-btn btn ml-2"
                                onClick={() => {
                                  close(index, areaIndex);
                                }}
                              >
                                Close
                              </button>
                              <button
                                type="button"
                                className="primary-md-btn btn ml-2"
                                onClick={() => {
                                  handleSubmit(index, areaIndex);
                                }}
                                disabled={loading}
                              >
                                {loading ? (
                                  <Spinner animation="border" />
                                ) : (
                                  "Save"
                                )}
                              </button>
                            </div>
                          </>
                        )}
                        {!subjectData.areas.some((area) => area.isEditing) &&
                          areaIndex === subjectData.areas.length - 1 && (
                            <div className="p-2">
                              <button
                                className="btn ternary-text"
                                type="button"
                                onClick={() => handleAddArea(index)}
                              >
                                + Add New Area
                              </button>
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </form>
      <ModalComponent
        show={showDeleteConfirmation}
        onHide={() => {
          setShowDeleteConfirmation(false);
        }}
        title={t("Delete")}
        onCancel={t("Cancel")}
        onConfirm={t("Confirm")}
        subTitle={t("Are you sure, to delete this Subject?")}
        size="sm"
        onCancelClick={() => {
          setShowDeleteConfirmation(false);
        }}
        onConfirmClick={handleRemoveSubject}
      />
    </>
  );
};
export default ToastHOC(DevelopmentArea);
